import flatMap from 'lodash/flatMap'
import uniqBy from 'lodash/uniqBy'
import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'

import { FooterElement, SectionTitle, Text } from '@Components/Footer/styled'
import { PaymentIcons } from '@Components/Payment/PaymentIcons'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

const StyledPayment = styled(FooterElement)`
  order: 1;
`

export const Payment = () => {
  const { paymentMethods } = useContext(MetadataContext)

  const paymentIcons = useCallback(
    () => uniqBy(flatMap(paymentMethods, 'icons'), 'name'),
    [paymentMethods],
  )

  const { t } = useTranslation()
  return (
    <StyledPayment className="top">
      <SectionTitle>
        {t('footer:PAYMENT_OPTIONS')}
      </SectionTitle>
      <Text>
        {t('footer:PAYMENT_OPTIONS_FOOTER_TEXT')}
      </Text>
      <PaymentIcons icons={paymentIcons()} />
    </StyledPayment>
  )
}
